/**
 * Polyfill para process.env
 * Necesario para react-scripts 4.0.3 con Node.js 22+
 * Asegura que process.env esté disponible en el navegador
 * 
 * IMPORTANTE: Este polyfill solo crea la estructura si no existe.
 * NO sobrescribe las variables que webpack ya haya inyectado.
 */

// Helper: Inicializar process.env en window
function initWindowProcess() {
  if (typeof window === 'undefined') {
    return;
  }
  if (typeof window.process === 'undefined') {
    window.process = {};
  }
  if (typeof window.process.env === 'undefined') {
    window.process.env = {};
  }
}

// Helper: Inicializar process.env en global
function initGlobalProcess() {
  if (typeof global === 'undefined' || typeof global.process !== 'undefined') {
    return;
  }
  // eslint-disable-next-line no-global-assign
  global.process = typeof window !== 'undefined' ? window.process : {};
  if (typeof global.process.env === 'undefined') {
    global.process.env = {};
  }
}

// Helper: Asignar process global si no existe
function assignGlobalProcess() {
  if (typeof process !== 'undefined') {
    return;
  }
  // eslint-disable-next-line no-native-reassign, no-undef
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-native-reassign
    process = window.process;
  } else if (typeof global !== 'undefined') {
    // eslint-disable-next-line no-native-reassign
    process = global.process || { env: {} };
  } else {
    // eslint-disable-next-line no-native-reassign
    process = { env: {} };
  }
}

// Ejecutar inmediatamente usando IIFE para asegurar ejecución temprana
(function() {
  initWindowProcess();
  initGlobalProcess();
  assignGlobalProcess();
  // Nota: Si process ya existe (inyectado por webpack), process.env ya está definido
  // No necesitamos verificar ni asignar process.env aquí para evitar problemas con el minificador
})();

